import React from "react";
import { Layout, Button, Dropdown, Avatar } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Logo from "./Logo";

const { Header } = Layout;

const StyledHeader = styled(Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0076ce;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export default function AppHeader({ programName, isLoggedIn, handleLogout }) {
  // Build your menu items
  const menuConfig = {
    items: [
      {
        key: "profile",
        label: <Link to={programName + "/participantprofile"}>Profile</Link>,
      },
      {
        type: "divider",
      },
      {
        key: "signout",
        label: "Sign Out",
        onClick: handleLogout,
      },
    ],
  };

  return (
    <StyledHeader role="navigation" aria-label="Main Navigation">
      <Link to="/">
        <Logo programName={programName} />
      </Link>

      {isLoggedIn ? (
        <Button
          style={{ color: "white" }}
          size="medium"
          type="text"
          onClick={handleLogout}
        >
          Sign Out
        </Button>
      ) : (
        <Button
          style={{ color: "white" }}
          size="medium"
          type="text"
          onClick={() => (window.location.href = `/${programName}/sign-in`)}
        >
          Sign in
        </Button>
      )}
    </StyledHeader>
  );
}
